import AbortControllerWithParent from "../models/AbortControllerWithParent.model.ts";
const serverUrl = process.env.REACT_APP_BASE_URL
const serverApiKey = process.env.REACT_APP_API_KEY

export async function createUser(email, opts = {})
{
    const {
        timeoutMs = 10000,
        signal,                  
    } = opts;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
    const combinedSignal = signal 
            ? new AbortControllerWithParent(signal, controller).signal
            : controller.signal;

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-API-Key": serverApiKey        
    };

    try {       

        const res = await fetch(`${serverUrl}/user/create`,{
            body: new URLSearchParams({email}),
            method: "POST",            
            headers: headers,
            mode:'cors',
            signal: combinedSignal,
            credentials: "same-origin",
        });
        const data = await res.json().catch(() => ({        
        }));

        if(!res.ok)
        {
            const message = data?.message || 
                            data?.detail ||
                            `Request failed with status ${res.status}`;
            const error = new Error(message);
            error.status = res.status;
            error.data = data;
            throw error;
        }
        
        return data;
    }
    finally
    {
        clearTimeout(timeoutId);
    }
}